// @ts-nocheck
export default {
    SET_WORKER_DELIVERY_FEE_GROUP: (state, data) => {
        state.workerDeliveryFeeGroup = data;
    },
    SET_AGENCY_SHARE_INFO: (state, data) => {
        state.agencyShareInfoList = data;
    },
};
